/**
 * Asynchronously loads the component for Home
 */

import { lazyLoad } from 'utils/loadable';

export const WaitingResident = lazyLoad(
  () => import('./index'),
  module => module.default,
);
